import bnc from "bnc";

export const block = new bnc('course-sidebar-header');
